// extracted by mini-css-extract-plugin
export default {"servicesContainer":"styles_servicesContainer__XsnG2","services":"styles_services__7SHVF","deleteContainer":"styles_deleteContainer__qQ89x","deleteBtn":"styles_deleteBtn__7Uweq"};